import { cn } from "@omni/utils/styles";
import { ComponentProps } from "react";

type Props = ComponentProps<"h1">;

export const H1 = ({ ...props }: Props) => {
    return (
        <h1
            {...props}
            className={cn(
                "tw:text-3xl tw:font-normal tw:mt-4 tw:mb-5 tw:mx-0 tw:leading-[1.2]",
                props.className
            )}
        >
            {props.children}
        </h1>
    );
};
